<template>
	<div>
		<div class="row">
			<div class="col-md-6">
				<h2 class="text-primary" style="margin-bottom: 0px">
					<i class="fas fa-chart-line" /> Fluxo de caixa
				</h2>
			</div>
			<div class="col-md-6 text-right">
				<button
					class="btn btn-sm btn-primary mr-2"
					@click="$router.push('/fluxodecaixa/planodecontas')"
				>
					<i class="fas fa-cog mr-1" />
					Plano de contas
				</button>
			</div>
		</div>
		<!-- <b-row align-h="between">
			<h2 class="text-primary">
				<i class="fas fa-chart-line" /> Fluxo de caixa
			</h2>
			<button
				class="btn btn-sm btn-primary mr-2"
				@click="$router.push('/fluxodecaixa/planodecontas')"
			>
				<i class="fas fa-cog" />
				Plano de contas
			</button>
		</b-row> -->

		<br />

		<b-tabs pills>
			<hr />
			<b-tab title="Resumo" active>
				<template v-slot:title>
					<i class="fas fa-chart-line" /> Resumo
				</template>
				<cash-flow-resume />
			</b-tab>
			<b-tab title="Movimentações">
				<template v-slot:title>
					<i class="fas fa-list-ul" /> Movimentações
					<span class="badge badge-info text-white" style="text-indent: 0px"
						>Novo</span
					>
				</template>
				<cash-flow-moviments />
			</b-tab>
		</b-tabs>
	</div>
</template>
<script>
	import CashFlowMoviments from "@/components/account/sections/CashFlowMoviments";
	import CashFlowResume from "@/components/account/sections/CashFlowResume";
	import Filter from "@/mixins/Filters.js";
	import moment from "moment";

	export default {
		components: {
			CashFlowResume,
			CashFlowMoviments,
		},

		data: function () {
			return {};
		},

		created() { },

	};
</script>

<style>
</style>